import { combineReducers } from 'redux';
import prospectTabReducer from './ProspectTab/reducer';

import {
  GENERATE_PETITION_REQUEST,
  GENERATE_PETITION_SUCCESS,
  GENERATE_PETITION_FAILED,
  FETCH_PARENT_PETITIONS_REQUEST,
  FETCH_PARENT_PETITIONS_SUCCESS,
  FETCH_PARENT_PETITIONS_FAILED,
  SET_NUMBER,
  SET_TYPE,
  SET_ERROR,
  SET_PARENT_PETITION_ID,
  COVER_PAGE_ONLY_TOGGLE,
  TOGGLE_GENERATE_CSV,
} from './actionTypes';

import assignTableReducer from './AssignTable/reducer';

const initialState = {
  loading: false,
  parentPetitionsList: [],
  number: 1,
  parentPetitionId: 0,
  generateType: 'blank',
  coverPageOnly: false,
  error: '',
  generateCsv: false,
};

const generateReducer = (
  state = initialState,
  { type, number, error, parentPetitionId, parentPetitionsList, generateType },
) => {
  switch (type) {
    case SET_NUMBER:
      return {
        ...state,
        number,
        error: '',
      };
    case SET_TYPE:
      return {
        ...state,
        generateType,
        error: '',
      };
    case GENERATE_PETITION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GENERATE_PETITION_SUCCESS:
      return {
        ...state,
        number: 1,
        parentPetitionId: 0,
        generateType: 'blank',
        loading: false,
      };
    case GENERATE_PETITION_FAILED:
      return {
        ...state,
        loading: false,
        error,
      };
    case FETCH_PARENT_PETITIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PARENT_PETITIONS_SUCCESS:
      return {
        ...state,
        parentPetitionsList,
        loading: false,
      };
    case FETCH_PARENT_PETITIONS_FAILED:
      return {
        ...state,
        loading: false,
        error,
      };
    case SET_ERROR:
      return {
        ...state,
        loading: false,
        error,
      };
    case SET_PARENT_PETITION_ID:
      return {
        ...state,
        parentPetitionId,
        loading: false,
      };
    case COVER_PAGE_ONLY_TOGGLE:
      return {
        ...state,
        coverPageOnly: !state.coverPageOnly,
      };
    case TOGGLE_GENERATE_CSV:
      return {
        ...state,
        generateCsv: !state.generateCsv,
      };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  main: generateReducer,
  prospectTab: prospectTabReducer,
  assignTable: assignTableReducer,
});

export default rootReducer;
